import styled from 'styled-components'

import { Flex } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex).withConfig({
  shouldForwardProp,
})`
  flex-direction: column;
`
